<template>
  <TabbedBox :useQueryNavigation="true">
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-inventory-value-stockcat">
        <i class="far fa-layer-group"></i> Value - Categories
      </Tab>
      <Tab tabid="tab-inventory-value-stock">
        <i class="far fa-inventory"></i> Value - Stock
      </Tab>
      <Tab tabid="tab-inventory-value-offcuts">
        <i class="far fa-layer-group"></i> Value - Offcuts
      </Tab>
      <Tab tabid="tab-inventory-value-blocks">
        <i class="far fa-box"></i> Value - Blocks
      </Tab>
      <Tab tabid="tab-inventory-onhand-categories">
        <i class="far fa-layer-group"></i> On Hand - Categories
      </Tab>
      <Tab tabid="tab-inventory-onhand-stock">
        <i class="far fa-inventory"></i> On Hand - Stock
      </Tab>
      <Tab tabid="tab-inventory-onhand-offcuts">
        <i class="far fa-layer-group"></i> On Hand - Offcuts
      </Tab>
      <Tab tabid="tab-inventory-onhand-blocks">
        <i class="far fa-box"></i> On Hand - Blocks
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-inventory-value-stockcat">
        <InventoryValueSummaryList title="Inventory Value - Categories" :valueList="valueCategoryList" dataTitle="Value" />
      </TabPage>
      <TabPage tabid="tab-inventory-value-stock">
        <InventoryValueSummaryList title="Inventory Value - Stock" :valueList="valueStockList" dataTitle="Value" />
      </TabPage>
      <TabPage tabid="tab-inventory-value-offcuts">
        <InventoryValueSummaryList title="Inventory Value - Offcuts" :valueList="valueOffcutList" dataTitle="Value" />
      </TabPage>
      <TabPage tabid="tab-inventory-value-blocks">
        <InventoryValueSummaryList title="Inventory Value - Blocks" :valueList="valueBlockList" dataTitle="Value" />
      </TabPage>
      <TabPage tabid="tab-inventory-onhand-categories">
        <InventoryValueSummaryList title="Inventory On Hand - Categories" :valueList="onHandCategoryList" dataTitle="Area" />
      </TabPage>
      <TabPage tabid="tab-inventory-onhand-stock">
        <InventoryValueSummaryList title="Inventory On Hand - Stock" :valueList="onHandStockList" dataTitle="Area" />
      </TabPage>
      <TabPage tabid="tab-inventory-onhand-offcuts">
        <InventoryValueSummaryList title="Inventory On Hand - Offcuts" :valueList="onHandOffcutList" dataTitle="Area" />
      </TabPage>
      <TabPage tabid="tab-inventory-onhand-blocks">
        <InventoryValueSummaryList title="Inventory On Hand - Blocks" :valueList="onHandBlockList" dataTitle="Count" />
      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

import Utils from '@/utils/utils'
import InventoryValueSummaryList from '@/modules/intelligence/components/inventoryValueSummaryList'

export default {
  name: 'InventoryGroups',
  components: {
    InventoryValueSummaryList
  },
  data() {
    return {
      inventorySummary: {}
    }
  },
  computed: {
    valueCategoryList() {
      if(!this.inventorySummary.categoryValueList)
        return []
      return this.inventorySummary.categoryValueList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatCurrency(group.value)
        }
      })
    },
    valueStockList() {
      if(!this.inventorySummary.stockValueList)
        return []
      return this.inventorySummary.stockValueList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatCurrency(group.value),
          stockId: group.id
        }
      })
    },
    valueOffcutList() {
      if(!this.inventorySummary.offcutValueList)
        return []
      return this.inventorySummary.offcutValueList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatCurrency(group.value),
          stockId: group.id
        }
      })
    },
    valueBlockList() {
      if(!this.inventorySummary.blockValueList)
        return []
      return this.inventorySummary.blockValueList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatCurrency(group.value),
          stockId: group.id
        }
      })
    },
    onHandCategoryList() {
      if(!this.inventorySummary.categoryOnHandList)
        return []
      return this.inventorySummary.categoryOnHandList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatDecimal(group.value, 2, true) + 'm&sup2;',
        }
      })
    },
    onHandStockList() {
      if(!this.inventorySummary.stockOnHandList)
        return []
      return this.inventorySummary.stockOnHandList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatDecimal(group.value, 2, true) + 'm&sup2;',
          stockId: group.id
        }
      })
    },
    onHandOffcutList() {
      if(!this.inventorySummary.offcutOnHandList)
        return []
      return this.inventorySummary.offcutOnHandList.map(group => {
        return {
          name: group.name,
          displayValue: this.formatDecimal(group.value, 2, true) + 'm&sup2;',
          stockId: group.id
        }
      })
    },
    onHandBlockList() {
      if(!this.inventorySummary.blockCountList)
        return []
      return this.inventorySummary.blockCountList.map(group => {
        return {
          name: group.name,
          displayValue: group.value,
          stockId: group.id
        }
      })
    }    
  },
  mounted() {
    this.requestSummary()
  },
  beforeDestroy() {
  },
  methods: {
    requestSummary() {

      var summaryFilter = {
        maxGroupSize: 0
      }

      this.$apiService.analyticsService.getStockValueOnHandSummary(summaryFilter)
      .then(response => {
        this.inventorySummary = response.data
      })
    }
  }
}
</script>
